module.exports = __webpack_public_path__ + "media/אפרסק.318725de.mp3";